//Setup Help
function setupHelp() {
    $('.rtHelpButton').attr('href', 'javascript:void(0);');
    $('.rtHelpButton').attr('target', '');
    $('.rtHelpMessage').click(function () { $(this).hide(); });
}


//Help
function rtHelpOpen(HelpMessage, LinkId) {
    HelpMessage = $('#' + HelpMessage)
    HelpMessage.text('Loading....');
    HelpMessage.show();
    HelpMessage.load('/help/summary/' + LinkId,
        function () {
            var textReturned = HelpMessage.text();
            if (textReturned.startsWith('open:')) {
                textReturned = textReturned.substring(5);
                window.open('/help/' + textReturned);
                HelpMessage.hide();
            }
        }
    );
}
//Help
function rtHelpOpenMessage(HelpMessage, Text) {
    HelpMessage = $('#' + HelpMessage)
    HelpMessage.html(Text);
    HelpMessage.show();
}